// @ts-check
import {
  StyledConfiguration,
  StyledConfigurationFooter,
  StyledHeader
} from './Configuration.style';
import { useHistory } from 'react-router-dom';
import useInvestmentCarvingSetting from './useInvestmentCarvingSetting/useInvestmentCarvingSetting';
import useFormSaveHandler from './useFormState/useFormSaveHandler';
import { WhiteSection } from 'components/base/layout-components';
import Icon from 'components/base/Icon';
import CategoriesConfig from './CategoriesConfig';
import useFormState from './useFormState/useFormState';
import AppRouter from 'common/AppRouter';
import InvestmentBenchmarks from './InvestmentBenchmarks';
import RevertToDefault from './RevertToDefault';
import { LBButton } from '@linearb/buzz';

const Configuration = () => {
  const history = useHistory();
  const investmentCarvingSetting = useInvestmentCarvingSetting();
  const defaultSelectedCategory = history.location.state?.selectedCategory;
  const formState = useFormState({
    defaultValue: investmentCarvingSetting.value,
    defaultSelectedCategory
  });
  const formSaveHandler = useFormSaveHandler({
    investmentCarvingSetting,
    formState
  });

  const onClose = () =>
    history.replace(AppRouter.PROJECTS_INVESTMENT_CARVING.path);

  return (
    <StyledConfiguration>
      <WhiteSection>
        <StyledHeader>
          Investment Profile Report Settings
          <div className='ml-auto'>
            <LBButton variant='ghost' size='icon' onClick={onClose}>
              <Icon name='close' size='x-medium' />
            </LBButton>
          </div>
        </StyledHeader>
        <CategoriesConfig formState={formState} />
        <InvestmentBenchmarks formState={formState} />
        <StyledConfigurationFooter>
          <RevertToDefault onClick={formSaveHandler.onRevertToDefaults} />
          <LBButton
            onClick={async () => {
              await formSaveHandler.onSaveConfiguration();
              onClose();
            }}
            disabled={formSaveHandler.isSaveDisabled}
          >
            Save & Close
          </LBButton>
        </StyledConfigurationFooter>
      </WhiteSection>
    </StyledConfiguration>
  );
};

export default Configuration;
